import React from 'react';
import { isPolyline } from '../../../../services/here-maps/here-map-wrapper';
import { HereMapColors } from '../../../../styles/agistics-colors';
import { HereMapContext } from '../../../here-maps/here-map-context';

interface BulkScheduleHoverProps {
    hoveredDraftId: number | null;
}

export const BulkScheduleHover = (props: BulkScheduleHoverProps) => {
    const { hoveredDraftId } = props;
    const hereMapContext = React.useContext(HereMapContext);

    React.useEffect(() => {
        if (hereMapContext.map) {
            const mapObjects = hereMapContext.map.getObjects();

            const mapPolylines = mapObjects.filter((mapObject) => {
                const polyline = isPolyline(mapObject)
                return polyline;
            });

            mapPolylines.map(mapPolyline => {
                const polylineData = mapPolyline.getData();
                if (hoveredDraftId === polylineData.loadId) {
                    mapPolyline.setStyle({
                        lineWidth: 4,
                        strokeColor: HereMapColors.HIGHLIGHTED_ROUTE,
                    });
                    mapPolyline.setZIndex(100);
                } else {
                    mapPolyline.setStyle({
                        lineWidth: 4,
                        strokeColor: HereMapColors.CALCULATED_ROUTE,
                    });
                    mapPolyline.setZIndex(0);
                }
            });
        }
    }, [hoveredDraftId]);

    return null;
};
